import { theme } from '@dasa-health/components-react'
import styled from 'styled-components'

export const OpenModal = styled.button`
    background: none;
    border: 0;
    margin: 0;
    padding: 0;
    text-decoration: underline;
    color: blue;
    font-family: 'Dasa Sans', 'Montserrat', sans-serif;
    font-size: 16px;
    text-align: left;
    width: 128px;
    cursor: pointer;
`

export const PageTemplate = styled.div`
    height: 100%;
    display: grid;
    grid-template-rows: min-content auto;

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        grid-template-rows: min-content min-content;
    }
`
